import { AppState } from "../../app.state";

export const myWorkflowsRequest = (state: AppState) => state.myWorkflowsRequests